import * as React from 'react';
import {Box} from "@mui/system";
import DeleteScheduleAction from "./DeleteScheduleAction";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import {Link} from "react-router-dom";

export default function ScheduleActionsContainer({ scheduleId, organizationId, handleName }) {
    return (
        <Box sx={style.actionButtonsContainer}>
            <Link to={`/admin/schedules/${scheduleId}/edit?organization=${organizationId}`}>
                <Tooltip title={'Edit schedule'} componentsProps={{tooltip: { sx: style.tooltip }}}>
                    <IconButton component={'button'} size={'small'}>
                        <EditIcon sx={style.editIcon}/>
                    </IconButton>
                </Tooltip>
            </Link>
            <Box sx={{ml: '5px'}}>
                <DeleteScheduleAction organizationId={organizationId} scheduleId={scheduleId} handleName={handleName} />
            </Box>
        </Box>
    )
}

const style = {
    actionButtonsContainer: {
        display: 'flex',
        justifyContent: "flex-end"
    },
    tooltip: {
        backgroundColor: '#DBD8FF',
        color: '#0C2728',
        fontFamily: 'LarsseitMedium',
        fontSize: '13px',
    },
    editIcon: {
        color:'#07857C',
        fontSize: '20px',
        textAlign: 'right'
    },
}